var InputHandler = /** @class */ (function () {
    function InputHandler() {
    }
    InputHandler.getInstance = function () {
        if (!this._instance) {
            this._instance = new InputHandler();
        }
        return this._instance;
    };
    InputHandler.prototype.load = function (scene) {
        this.scene = scene;
        return this;
    };
    InputHandler.prototype.on = function (event, listener) {
        this.scene.input.on(event, listener);
    };
    return InputHandler;
}());
export default InputHandler;
